import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAndroidstudio,
  SiPostman,
  SiIntellijidea,
  SiGithub,
  SiFigma
} from "react-icons/si";
import { DiGit } from "react-icons/di";
import { VscVscode } from "react-icons/vsc";

const tools = [
  { icon: <SiAndroidstudio />, name: "Android Studio", link: "https://developer.android.com/studio" },
  { icon: <SiIntellijidea />, name: "IntelliJ IDEA", link: "https://www.jetbrains.com/idea/" },
  { icon: <VscVscode />, name: "VS Code", link: "https://code.visualstudio.com/" },
  { icon: <SiPostman />, name: "Postman", link: "https://www.postman.com/" },
  { icon: <DiGit />, name: "Git", link: "https://git-scm.com/" },
  { icon: <SiGithub />, name: "GitHub", link: "https://github.com/" },
  { icon: <SiFigma />, name: "Figma", link: "https://www.figma.com/" }
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} sm={3} md={2} key={index} className="d-flex justify-content-center mb-4">
          <a
            href={tool.link}
            target="_blank"
            rel="noopener noreferrer"
            className="tech-icons"
            style={{
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {tool.icon}
            <span className="tech-icons-text">{tool.name}</span>
          </a>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
